import { useEffect, useState, type ReactNode } from "react";
import useEmblaCarousel from "embla-carousel-react";

export function TrendingCarousel<T extends { _id?: string | number }>({
  items,
  renderItem,
}: {
  items: T[];
  renderItem: (item: T) => ReactNode;
}) {
  const [emblaRef, embla] = useEmblaCarousel({ loop: true, align: "center" });
  const [selected, setSelected] = useState(0);
  const [snaps, setSnaps] = useState<number[]>([]);

  useEffect(() => {
    if (!embla) return;
    const onSelect = () => setSelected(embla.selectedScrollSnap());
    setSnaps(embla.scrollSnapList());
    embla.on("select", onSelect);
    embla.on("reInit", () => {
      setSnaps(embla.scrollSnapList());
      onSelect();
    });
    onSelect();
  }, [embla]);

  return (
    <div className="md:hidden">
      <div className="relative">
        <div className="overflow-hidden" ref={emblaRef}>
          <div className="flex">
            {items.map((item, i) => (
              <div
                key={item._id ?? i}
                className="min-w-0 shrink-0 grow-0 basis-full px-2"
              >
                {renderItem(item)}
              </div>
            ))}
          </div>
        </div>
      </div>
      {items.length > 1 && (
        <div className="mt-6 flex justify-center gap-2">
          {snaps.map((_, i) => (
            <button
              key={i}
              type="button"
              aria-label={`Go to trending article ${i + 1}`}
              onClick={() => embla?.scrollTo(i)}
              className={`h-2 rounded-full transition-all ${
                i === selected ? "w-6 bg-text-primary" : "w-2 bg-text-primary/30"
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
}